export const ModuleConst = {
  Dashboard: 1,
  Products: 2,
  Orders: 3,
  orderManagement: 3.1,
  Returns: 3.2,
  Outlets: 4,
  Reviews: 5,
  Reports: 6,
  SubAdmin:7,
  Settings: 8,
  Brands: 10,
  Outlet: 11,
};
